var map = {
	"./bg.svg": 1237,
	"./city_package.svg": 1238,
	"./fast_ok.svg": 1239,
	"./including_baggage-no-available.svg": 949,
	"./including_baggage.svg": 950,
	"./including_transfer.svg": 1240,
	"./lowcost.svg": 1241,
	"./not_including_baggage.svg": 1242,
	"./not_including_transfer.svg": 1243,
	"./triangle.svg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1236;